import { inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { map } from 'rxjs';

import { ConfirmDialogComponent } from 'admin/shared/confirm-dialog/confirm-dialog.component';

export type HasUnsavedChanges = {
  hasUnsavedChanges(): boolean;
};

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (
  component,
  currentRoute,
  currentState,
  nextState,
) => {
  if (!component.hasUnsavedChanges()) {
    return true;
  }

  // The unauthorized interceptor redirects to /auth/login on 401 while a form
  // is dirty; that navigation should not be blocked behind a confirmation.
  if (nextState?.url?.startsWith('/auth')) {
    return true;
  }

  const dialog = inject(MatDialog);

  // Reuse an already-open confirm dialog instead of stacking a second one on
  // top of it (e.g. two deactivate checks racing on the same navigation).
  const existingRef = dialog.openDialogs.find(
    (ref): ref is MatDialogRef<ConfirmDialogComponent, boolean> =>
      ref.componentInstance instanceof ConfirmDialogComponent,
  );

  const dialogRef =
    existingRef ??
    dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Незбережені зміни',
        message: 'У формі є незбережені зміни. Якщо ви залишите сторінку, вони будуть втрачені.',
        confirmLabel: 'Залишити сторінку',
        cancelLabel: 'Скасувати',
      },
    });

  return dialogRef.afterClosed().pipe(map((confirmed) => confirmed === true));
};
